<div
  class="ancillary-bundle-selection flex flex--column"
  [attr.data-testid]="'ancillary-bundle-selection-' + category()"
>
  <fcom-product-card
    [originalPrice]="product()?.originalPrice | finNonZeroAmount: hideZeroPrices() | finPrice | finEmpty: ''"
    [title]="product()?.title"
    [detailText]="product()?.description | finStripHtml | finEmpty: ''"
    [showDetailText]="true"
    [hideButton]="true"
    [image]="product()?.image"
    [productTags]="product()?.productTags ?? []"
    [useNewProductCardLayout]="true"
    [variant]="ProductCardVariant.SECONDARY"
  />

  <hr class="ms-xxlarge-y nordic-blue-100-border border-primary" aria-hidden="true" />

  @let bundleConstituents = constituents();
  @let availability = availabilityByPax();
  @let selections = selectionsByPax();
  @let tierBenefit = tierBenefitByPax();
  @for (passenger of passengers(); track passenger.id) {
    <fin-bundle-offer-card
      class="ms-large-b"
      [passenger]="passenger"
      [constituents]="bundleConstituents"
      [availability]="availability[passenger.id] ?? null"
      [selectedForPassenger]="!!selections[passenger.id]"
      [isBundleAncillariesIncludedInTier]="tierBenefit[passenger.id] ?? false"
      (addCombo)="addCombo(passenger)"
      (removeCombo)="removeCombo(passenger)"
    />
  }
</div>
